import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";

import "./Layout.css";

const TwitterIcon = () => <svg viewBox="0 0 300 271" xmlns="http://www.w3.org/2000/svg">
  <path fill="#fff" d="m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z"/>
  </svg>;

const FeedIcon = () => 
<svg viewBox="74 174 850 850" xmlns="http://www.w3.org/2000/svg">
   <path fill="#fff"
d="M75 175v170q135 0 260 52t220.5 147.5t147.5 220.5t52 260h170q0 -169 -64.5 -325t-184.5 -275.5t-276 -184.5t-325 -65zM75 462v165q79 0 152.5 30.5t129.5 86.5t86 129t30 152h165q0 -112 -42.5 -215.5t-122 -182.5t-183 -122t-215.5 -43zM192 792q-32 0 -59 16
t-42.5 42.5t-15.5 58.5t15.5 58.5t42.5 42t58.5 15.5t58.5 -15.5t42.5 -42t15.5 -58.5t-15.5 -58.5t-42.5 -42.5t-58 -16z" />
</svg>;

const LinkedinIcon = () => 
<svg  viewBox="124 7319 20 20"xmlns="http://www.w3.org/2000/svg" >
<path fill="#fff" d="M144,7339 L140,7339 L140,7332.001 C140,7330.081 139.153,7329.01 137.634,7329.01 C135.981,7329.01 135,7330.126 135,7332.001 L135,7339 L131,7339 L131,7326 L135,7326 L135,7327.462 C135,7327.462 136.255,7325.26 139.083,7325.26 C141.912,7325.26 144,7326.986 144,7330.558 L144,7339 L144,7339 Z M126.442,7323.921 C125.093,7323.921 124,7322.819 124,7321.46 C124,7320.102 125.093,7319 126.442,7319 C127.79,7319 128.883,7320.102 128.883,7321.46 C128.884,7322.819 127.79,7323.921 126.442,7323.921 L126.442,7323.921 Z M124,7339 L129,7339 L129,7326 L124,7326 L124,7339 Z" />
</svg>

const YEAR = Math.max(2025, new Date().getFullYear());

const Layout = ({ noPadding, onHome, onCode, children, noContainer } ) => {

  return (
    <div
      className={classNames("Layout", {
        "--noPadding": noPadding
      })}
    >
      <LayoutHeader onHome={onHome} onCode={onCode}
        />
      <div className="Layout-content">
        {
          noContainer
          ?
          children
          :
          <div className="container">{children}</div>
        }
      </div>
      <footer>
        {/*
        <div className="container">
          <a href="https://www.airbnb.com.au/c/bjoffe19?currency=AUD">
            Get more than $50 off your first trip on AirBnB.
          </a>
        </div>
        */}
        <div className="container">
          <p>&copy; {YEAR} Ben Joffe</p>
        </div>
      </footer>
    </div>
  );
};

export const LayoutHeader = ({onHome,onCode}) =>
  <header className="LayoutHeader --transBg">
    <div className="container">

      <div className="-cols">
        <div>
          {onHome ? <h1>Ben Joffe</h1> : <strong>Ben Joffe</strong>}
          <nav>
            <ul>
              <li className={onHome ? '--on' : ''}>
                {onHome ? <span>Articles</span> :
                  <Link to="/">Articles</Link>
                }
              </li>
              <li className={onCode ? '--on' : ''}>
                {onCode ? <span>Lab</span> :
                  <Link to="/code">Lab</Link>
                }
              </li>
              {/*
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              */}
            </ul>
          </nav>
        </div>
        <ul className="-networks">
          <li>
            <a
              // eslint-disable-next-line
              target="_blank"
              href="/rss.xml"
            >
              <span>RSS Feed</span>
              <FeedIcon />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://x.com/benjoffe"
            >
              <span>X (Twitter)</span>
              <TwitterIcon />
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/benjoffe"
            >
              <span>LinkedIn</span>
              <LinkedinIcon />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </header>;

export default Layout;